import { ApplicationSourceDto } from './applicationSource.dto';
import { BaseDto } from './base.dto';
import { CartOrderDto } from './cartOrder.dto';
import { CartProductDto } from './cartProduct.dto';
import { CustomerDto } from './customer.dto';
import { MerchantDto } from './merchant.dto';
import { OrderNoteOptionDto } from './orderNoteOption.dto';
import { PosDeviceDto } from './posDevice.dto';
import { SaleUnitCartDto } from "./saleUnitCart.dto";

export interface CartDto extends BaseDto {
  status: number;
  merchant: MerchantDto;
  applicationSource: ApplicationSourceDto;
  cartProducts: CartProductDto[];
  cartNoteOptions: OrderNoteOptionDto[];
  cartTotal?: number;
  customer?: CustomerDto;
  viewingPosDevice?: PosDeviceDto;
  tableTag?: string;
  cartOrders?: CartOrderDto[];
  saleUnitCarts?: SaleUnitCartDto[];
}
